import { environment } from '@/scripts/environments'

export function initializeDebugUtils(): void {
  window.__DEBUG__ = {
    env: {
      VITE_MODE: import.meta.env.MODE,
      NODE_ENV: process.env.NODE_ENV || 'N/A',
      VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
      VITE_BACKOFFICE_API_BASE_URL: import.meta.env
        .VITE_BACKOFFICE_API_BASE_URL,
      APP_VERSION: import.meta.env.APP_VERSION,
      environment,
    },
  }
}
